
import { RoutePermittedRole } from "shared/constants/AppConst";
import Transactions from "./transactions";

export const TransactionsConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageTransactions/",
    element: <Transactions />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageTransactions/Transactions",
    element: <Transactions />,
  },
];


